import {
    CashoutWsInterface,
    GeneralWsInterface,
    SbLiveDataInterface,
} from './interface/WsInterface';

class WebSocketsManager {
    #config;

    #cashoutWsInterface;
    #generalWsInterface;
    #sbLiveDataWsInterface;

    setup(config) {
        this.#config = config;
    }

    debug(wsInterface) {
        switch(wsInterface) {
            case 'cashout':
                return this.#cashoutWsInterface;
            case 'general':
                return this.#generalWsInterface;
            case 'sb_live_data':
                return this.#sbLiveDataWsInterface;
            default:
                throw new Error(`There is no ${wsInterface} Websocket interface`);
        }
    }

    get cashout() {
        if (!this.#cashoutWsInterface) {
            this.#cashoutWsInterface = new CashoutWsInterface(
                this.#config.cashout
            );
        }

        this.#cashoutWsInterface.connect();

        return this.#cashoutWsInterface;
    }

    get general() {
        if (!this.#generalWsInterface) {
            this.#generalWsInterface = new GeneralWsInterface(
                this.#config.general
            );
        }

        this.#generalWsInterface.connect();

        return this.#generalWsInterface;
    }

    get sb_live_data() {
        if (!this.#sbLiveDataWsInterface) {
            this.#sbLiveDataWsInterface = new SbLiveDataInterface(
                this.#config.sb_live_data,
            );
        }

        this.#sbLiveDataWsInterface.connect();

        return this.#sbLiveDataWsInterface;
    }

    destroyAll() {
        this.destroy('cashout');
        this.destroy('general');
        this.destroy('sb_live_data');
    }

    destroy(wsInterface) {
        switch(wsInterface) {
            case 'cashout':
                this.#cashoutWsInterface?.kill();
                this.#cashoutWsInterface = null;

                return;
            case 'general':
                this.#generalWsInterface?.kill();
                this.#generalWsInterface = null;

                return;
            case 'sb_live_data':
                this.#sbLiveDataWsInterface?.kill();
                this.#sbLiveDataWsInterface = null;

                return;
            default:
                throw new Error(`There is no ${wsInterface} Websocket interface`);
        }
    }
}

const wsManager = new WebSocketsManager();
if (localStorage.getItem('spectateWsManager:exposed') === 'yes') {
    window.spectateWsManager = wsManager;
}

export { wsManager };
